const state = {
  cediReload: [],
  cediEdit: null,
  cediDelete: null
}

export default state